import React, { Component } from 'react'
import { pure } from 'recompose'
import Rheostat from 'rheostat'
import classNames from 'classnames'

import './Slider.css'

const pad = (value) => value < 10 ? `0${value}` : value

const Values = ({values}) => {
    return (
        <p className="slider--values text--center">
            {`${pad(values[0])}:00 - ${pad(values[1])}:00`}
        </p>
    )
}

class Slider extends Component {
    
    constructor(props){
        super(props)
        this.state = {
            values: props.value,
            active: props.active
        }
    }

    updateValues = (value) => {
        const { values } = value
        this.setState({
            values
        })
    }
    
    setValues = (value) => {
        const { values } = value
        this.setState({
            values
        }, this.onChange)
    }

    toggle = () => {
        this.setState({
            active: !this.state.active
        }, this.onChange)
    }

    onChange = () => {
        const { day = '' } = this.props
        const { active, values } = this.state
        this.props.onChange({day, values, active})
    }

    render(){
        const { day = '', label='' } = this.props
        const { values, active } = this.state
        const id = `${day}-enabled`
        
        if(!values){
            throw new Error(`No times given for ${day}, times are ${values}. State: ${JSON.stringify(this.state)}, Props: ${JSON.stringify(this.props)}`);
        }
        return (
            <div className="slider">
                <Values values={values} />
                <div className="slider--control">
                    <input 
                        className="slider--checkbox"
                        type="checkbox"
                        name={id}
                        id={id}
                        defaultChecked={this.state.active}
                        onChange={this.toggle}
                    />
                    { label && <label htmlFor={id} className="slider--label">{label}</label> }
                    <Rheostat
                        className={classNames({'rheostat-disabled': !active})}
                        onChange={this.setValues}
                        onValuesUpdated={this.updateValues}
                        min={0}
                        max={24}
                        snap={true}
                        values={values}
                        disabled={!active}
                    />
                </div>
            </div>
        
        )
    }
}

Slider.defaultProps = {
    active: true
}

export default pure(Slider)


// WEBPACK FOOTER //
// ./src/components/Slider/Slider.js